import { render, staticRenderFns } from "./SBlender.vue?vue&type=template&id=47d9d7f9&scoped=true&"
import script from "./SBlender.vue?vue&type=script&lang=ts&"
export * from "./SBlender.vue?vue&type=script&lang=ts&"
import style0 from "./SBlender.vue?vue&type=style&index=0&id=47d9d7f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9d7f9",
  null
  
)

export default component.exports